declare global {
    interface Window {
        CRMGtag?: (...args: any[]) => void;
    }
}

import { defineUserStore } from '@/stores/user';

export const initGTag = () => {
    // 检查 CRMGtag 是否存在
    if (typeof window.CRMGtag !== 'function') {
        return;
    }
    
    try {
        window.CRMGtag('js', new Date());
        const hostname = window.location.hostname;
        const pid = hostname === 'salesgo.baidu-int.com' ? 'G-LC7BMRFWRY' : 'G-JYWHPWTJTC';
        const user_info = JSON.parse(localStorage.getItem('user') || '{}');
        console.log("user---", user_info?.base_info?.user_name);
        window.CRMGtag('config', pid, {
            cus_global_username: user_info?.base_info?.user_name
        });
    } catch (error) {
        console.error('initGTag error:', error);
    }
}

export const GACusEvent = {
    // event_name 的前缀都以 cus_xxx_xxx 等格式命名，和GA自动收集的事件区分；cus是 customize（自定义/定制）的缩写
    // event_parameters的指标名使用 cus_parameter1、cus_parameter2、cus_parameter3 ... 以此类推
    edit_btn_click: {
        event_name: 'cus_edit_btn_click',
        description: '编辑按钮点击次数',
        event_parameters: {
            cus_parameter1: ''
        }
    },
    release_follow_up_record_btn_click: {
        event_name: 'cus_release_follow_up_record_btn_click',
        description: '发布记录按钮点击次数',
        event_parameters: {}
    },
    search_btn_click: {
        event_name: 'cus_search_btn_click',
        description: '查询按钮点击次数',
        event_parameters: {}
    },
    query_duplicate_data_btn_click: {
        event_name: 'cus_query_duplicate_data_btn_click',
        description: '查重按钮点击次数',
        event_parameters: {}
    },
    export_btn_click: {
        event_name: 'cus_export_btn_click',
        description: '导出按钮点击次数',
        event_parameters: {}
    },
    lead_follow_up_status_change: {
        event_name: 'cus_lead_follow_up_status_change',
        description: '跟进记录下拉框更新次数',
        event_parameters: {}
    },
    client_deal_status_change: {
        event_name: 'cus_client_deal_status_change',
        description: '成交记录下拉框更改次数',
        event_parameters: {}
    },
    add_new_btn_click: {
        event_name: 'cus_add_new_btn_click',
        description: '新增按钮点击次数',
        event_parameters: {}
    },
    import_btn_click: {
        event_name: 'cus_import_btn_click',
        description: '导入按钮点击次数',
        event_parameters: {}
    },
    convert_client_btn_click: {
        event_name: 'cus_convert_client_btn_click',
        description: '转客户次数',
        event_parameters: {}
    },
    'create_lead_to_do_list_btn_click': {
        event_name: 'cus_create_lead_to_do_list_btn_click',
        description: '创建线索待办次数',
        event_parameters: {}
    },
    batch_status_change: {
        event_name: 'cus_batch_status_change',
        description: '批量改状态次数',
        event_parameters: {}
    },
    detail_page_view_btn_click: {
        event_name: 'cus_detail_page_view_btn_click',
        description: '详情页访问次数',
        event_parameters: {}
    },
    upload_attachment_btn_click: {
        event_name: 'cus_upload_attachment_btn_click',
        description: '附件上传次数',
        event_parameters: {}
    },
}

type EventParameters = {
    cus_parameter1?: string | number,
    cus_parameter2?: string | number,
    cus_parameter3?: string | number,
}

export const GATrack = (eventType: string, eventParameters?: EventParameters) => {
    const event_name = GACusEvent[eventType]['event_name'];

    const userStore = defineUserStore();
    const user_name = userStore.User?.base_info?.user_name;

    GACusEvent[eventType]['event_parameters']['cus_parameter1'] = user_name;

    const event_parameters = { ...GACusEvent[eventType]['event_parameters'], ...eventParameters };

    try {
        if (typeof window.CRMGtag === 'function') {
            window.CRMGtag && window.CRMGtag('event', event_name, event_parameters);
        }
    } catch (error) {
        console.log('gaReport Error:', error);
    }
}
